import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from './skeleton'

export function DocumentListSkeleton() {
  return (
    <div className="py-12s grid gap-4 md:grid-cols-2 xl:grid-cols-3">
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <Card key={i} className="flex flex-col">
          <div className="px-6 pt-6">
            <Skeleton className="mb-2 h-5 w-3/4" />
            <Skeleton className="h-4 w-24" />
          </div>
          <div className="mt-auto px-6 pb-6">
            <Skeleton className="mb-3 h-4 w-full" />
            <Skeleton className="h-9 w-full" />
          </div>
        </Card>
      ))}
    </div>
  )
}

export function DocumentReaderSkeleton() {
  return (
    <Card>
      <CardContent className="p-6 sm:p-8 sm:px-12 lg:px-16">
        <div className="space-y-6">
          <div className="space-y-2">
            <Skeleton className="h-8 w-64" />
            <Skeleton className="h-4 w-48" />
          </div>
          <div className="space-y-4">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="space-y-2">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-3/4" />
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export function EntryDetailSkeleton() {
  return (
    <div className="flex flex-1 flex-col gap-6">
      <div className="space-y-4">
        <div className="space-y-2">
          <Skeleton className="h-10 w-48" />
          <Skeleton className="h-6 w-32" />
        </div>
        <div className="space-y-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
        </div>
        <div className="space-y-2">
          <Skeleton className="h-6 w-24" />
          <Skeleton className="h-20 w-full" />
        </div>
      </div>
    </div>
  )
}

export function GenericCardSkeleton() {
  return (
    <Card>
      <CardContent className="py-12">
        <div className="space-y-4">
          <Skeleton className="h-6 w-3/4" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
        </div>
      </CardContent>
    </Card>
  )
}
